










import {Component, Prop, Vue} from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class Schedule extends Vue {
  @Prop() slide: any;

  grow(i: number) {
    if (i === this.items.length - 1) {
      return 0;
    }
    const t1 = moment(this.items[i].date);
    const t2 = moment(this.items[i + 1].date);
    return t2.diff(t1, 'days');
  }

  date(date: any) {
    if (moment(date).format('YYYYMMDD') === moment(new Date()).format('YYYYMMDD')) {
      return 'idag';
    }
    return moment(date).format('YYYY-MM-DD');
  }

  timeClass(date: any) {
    if (moment(date).format('YYYYMMDD') < moment(new Date()).format('YYYYMMDD')) {
      return 'passed';
    }
    if (moment(date).format('YYYYMMDD') === moment(new Date()).format('YYYYMMDD')) {
      return 'today';
    }
    return '';
  }

  get items() {
    const items = this.slide.items || [];
    return items.filter((x: any) => x.text && x.date).sort(
        (a: any, b: any) => Number(moment(a.date).format('YYYYMMDD')) - Number(moment(b.date).format('YYYYMMDD')));
  }
}
